import { QWebChannel } from "./qwebchannel";

var baseUrl = "";
// if (location.search != "") {
//   baseUrl = /[?&]webChannelBaseUrl=([A-Za-z0-9\-:/\.]+)/.exec(
//     location.search
//   )[1];
// } else {
//   baseUrl = "ws://localhost:12345";
// }
baseUrl = "ws://localhost:33333";

console.log("Connecting to WebSocket server at " + baseUrl + ".");
const socket = new WebSocket(baseUrl);
window.socketConect = socket
socket.onclose = function() {
  console.error("web channel closed");
};
socket.onerror = function(error) {
  console.error("web channel error: " + error);
};
socket.onopen = function() {
  console.log("WebSocket connected, setting up QWebChannel.");
  const a = new QWebChannel(socket, function(channel) {
    // make core object accessible globally
    window.core = channel.objects.core;
  });
  console.log(a)
};
